import React, {useState} from 'react';
import { connect } from 'react-redux';
import { loginUser, setUser } from '../../actions';
import { postData } from '../../utils/request';
import ContentLoader from "./ContentLoader";
import Button from "../form/Button";

class Login extends React.Component {

    state = {
        email: '',
        pw: '',
        disabled: false,
        forgotPassword: false
    };

    toggleForgotPassword = e => {
        e.preventDefault();
        this.setState({forgotPassword: !this.state.forgotPassword });
      }

      resetPassword = async () => {
        if (this.state.email !== ''){
            this.setState({disabled: true}, async () => {
                try {
                    const response = await postData({
                        action: "user.forgottenpw",
                        "email": this.state.email,
                    }, {}, {showError: false});
                    if (response.success) {
                        this.setState({
                            success: (response.msg ? response.msg : "Email elküldve!"),
                            disabled: false});
                    } else {
                        this.setState({
                            error: (response.msg ? response.msg : "Email küldés sikertelen!"),
                            disabled: false
                        });
                    }
                } catch (e) {
                    this.setState({
                        error: (e?.msg || e?.response?.data?.msg || "Email küldés sikertelen!"),
                        disabled: false
                    });
                }
            });
        }
      }

	login = async () => {
        if (this.state.email !== '' || this.state.pw !== '') {
            this.setState({disabled: true}, async () => {
                try {
                    const response = await postData({
                        action: "currentuser.loginuser",
                        "email": this.state.email,
                        "password": this.state.pw
                    }, {}, {showError: false});
                    if (response.success) {
                        await this.props.loginUser();
                        this.setState({disabled: false});
                    } else {
                        this.setState({
                            error: (response.msg ? response.msg : "Bejelentkezés sikertelen!"),
                            disabled: false
                        });
                    }
                } catch (e) {
                    this.setState({
                        error: (e.msg ? e.msg : "Bejelentkezés sikertelen!"),
                        disabled: false
                    });
                }
            });
        }
	}

	render() {
        const largelogo = (window.envBooqadmin.lastModified < 1 && process.env.WEBPACK_HOST) || (window.envBooqadmin.largelogo ? <span dangerouslySetInnerHTML={{__html: window.envBooqadmin.largelogo}}/> : <span><b>booq</b>admin</span>);
        const disabled = this.state.disabled;
        let content = null;
        if(this.props.user && !this.props.user.dispatch) {
            content =
                <div className="login-box-body">
                    <p className="login-box-msg">Kérem várjon!</p>
                    <ContentLoader/>
                </div>;
        } else {
            let message = null;
            if (!disabled) {
                if (this.state.error) {
                    message = <div className="alert alert-danger">{this.state.error}</div>;
                }
                if (this.state.success) {
                    message = <div className="alert alert-success">{this.state.success}</div>;
                }
                if (this.props.user.id !== null && this.props.user.hasPermission && !this.props.user.hasPermission(window.envBooqadmin.loginPrivilege || "admin")) {
                    message = <div className="alert alert-danger">Nincs "{window.envBooqadmin.loginPrivilege || "admin"}" jogosultságod!</div>;
                }
            }
            content = <form className="login-box-body" onSubmit={(e) => { this.state.forgotPassword ? this.resetPassword() : this.login(); e.preventDefault();}}>
                <p className="login-box-msg">{ this.state.forgotPassword ? "Jelszóemlékeztető küldése" : 'Az alkalmazás használatához jelentkezz be!'}</p>
                {message}
                <div className="form-group has-feedback">
                    <input type="email" className="form-control" required="required" disabled={disabled} onChange={(e)=> this.setState({ email: e.target.value })} placeholder="Email" />
                    <span className="glyphicon glyphicon-envelope form-control-feedback"/>
                </div>
   { !this.state.forgotPassword &&
                <div className="form-group has-feedback">
                    <input type="password" className="form-control" required="required" disabled={disabled} onChange={(e)=> this.setState({ pw: e.target.value })} placeholder="Jelszó" />
                    <span className="glyphicon glyphicon-lock form-control-feedback"/>
                </div>}
                <div className="row">
                    <div className="col-sm-6">
                        <div className="form-group">
                            <a href="#" className="btn btn-link" onClick={this.toggleForgotPassword}>{this.state.forgotPassword ? "Vissza" : "Elfelejtett jelszó"}</a>
                        </div>
                    </div>
                    <div className="col-sm-6">
                        <div className="form-group">
                            <Button color="primary" block={true} flat="true" disabled={disabled} type="submit">{this.state.forgotPassword ? "Küldés" : "Bejelentkezés"}</Button>
                        </div>
                    </div>
                </div>
            </form>;
        }
        return <div className="login-box">
            <div className="login-logo">
                <a href="#">{largelogo}</a>
            </div>
            {content}
            
        </div>;
	}
}

export default connect(
	(state) =>{
		return {
			user: state.app.user
		};
	},
	{
		loginUser,
        setUser
	}
)(Login);
